import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { WithdrawPayload } from '@monorepo/client-types';
import {
  Flex,
  FormInputNumber,
  TextComponent,
} from '@monorepo/react-components';
import { useResponsiveClassNames } from '@monorepo/react-hooks';
import { formatter, parser } from '../utils';

interface WithdrawalAmountSectionProps {
  form: UseFormReturn<WithdrawPayload>;
  maxWithdrawalLimit: number;
  whatUserGets: number;
  maximumWithdrawalMessage: string;
  handleMinimumValidation: (value: number) => string | true;
}

export const WithdrawalAmountSection: React.FC<
  WithdrawalAmountSectionProps
> = ({
  form,
  maxWithdrawalLimit,
  whatUserGets,
  maximumWithdrawalMessage,
  handleMinimumValidation,
}) => {
  const { t } = useTranslation(['withdrawFunds']);
  const responsiveInputClass = useResponsiveClassNames('withdrawal-amount');

  return (
    <Flex vertical align="center" gap={10}>
      <FormInputNumber
        className={responsiveInputClass}
        form={form}
        props={{
          formatter,
          parser,
        }}
        controllerProps={{
          name: 'amount',
          rules: {
            max: {
              value: maxWithdrawalLimit,
              message: maximumWithdrawalMessage,
            },
            validate: {
              minimum: handleMinimumValidation,
            },
          },
        }}
      />
      <TextComponent type="secondary">
        {t('withdrawFunds:profit_share', {
          whatUserGets,
        })}
      </TextComponent>
    </Flex>
  );
};
